import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';



@Component({
  selector: 'app-snack-bar-messages',
  imports: [CommonModule, MatIconModule, MatDialogModule],

  standalone: true,
  templateUrl: './snack-bar-messages.html',
  styleUrl: './snack-bar-messages.scss'
})
export class SnackBarMessages {
  constructor(
    public dialogRef: MatDialogRef<SnackBarMessages>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

export interface DialogData {
  textContentAsHTML: SafeHtml;
  warningLevel: 'info' | 'warn';
}
